var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76654 10C12.528 10 14.7665 7.76142 14.7665 5C14.7665 2.23858 12.528 0 9.76654 0C7.00512 0 4.76654 2.23858 4.76654 5C4.76654 7.76142 7.00512 10 9.76654 10ZM17.2383 14.067C12.8922 11.0249 7.10772 11.0249 2.76161 14.067L2.36214 14.3466C1.005 15.2965 0.548583 17.0973 1.28942 18.579C1.72487 19.4499 2.61501 20 3.58871 20H16.4112C17.3849 20 18.275 19.4499 18.7105 18.579C19.4513 17.0973 18.9949 15.2965 17.6377 14.3466L17.2383 14.067Z",
    fill: "#42474D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFrame);
export default __webpack_public_path__ + "static/media/UserFrame.b5a06b73a0681efaaabf82531e313e03.svg";
export { ForwardRef as ReactComponent };